import { createContext } from 'react';

import { Card } from 'src/models/card.model';
import { AnyValue, ID, Maybe, ParseMode, RecordObject } from 'src/models/general.model';

import { Scenario, Script } from 'src/models/scenario.model';

interface SpreadsheetParserType {
  card?: Card;
  companyTypes?: string[];
  fieldName?: string;
  isSearched?: boolean;
  mode?: ParseMode;
  recordId?: ID;
  row?: Record<string, unknown>;
  scenario?: Scenario;
  script?: Script;
  title?: string;
  tooltip?: string;
  isChecked?: boolean;
  isDisabled?: boolean; // style cell as disabled
  isInteractive?: boolean; // Parser can be clickable/editable/etc (e.g. clickable for billing popup)
  isActive?: boolean; // for checking readOnly status
  isLastChanged?: boolean; // to highlight bold values that was changed
  isTotals?: boolean; // for mixed type of row (e.g. header + totals for Summary tab on ReqSummary page)
  value?: AnyValue;
  statusLabel?: string;
  isAutobilling?: Maybe<boolean>; // if autobilling feature is enabled this flag will have true/false value
  dispatchAction?: (name: string, args?: AnyValue) => void; // parser and decorators can dispatch actions
  hasAction?: (name: string) => boolean; // function to check if action callback was provided
  classNames?: RecordObject<string>; // classes for styling
  onChange?: (value: AnyValue, isSubmit?: boolean) => void; // parser changes the value, with or without submission
  onClick?: () => void; // click on element
  onSubmit?: () => void; // submit current value
  onDiscard?: () => void; // discard changes
}

export const ParserContext = createContext({} as SpreadsheetParserType);
